"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMinBreakpoint = useMinBreakpoint;
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
var _breakpoint = _interopRequireDefault(require("@lmig/lmds-tokens/dist/json/core/breakpoint.json"));
var _useMediaQuery = require("./useMediaQuery");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function useMinBreakpoint(breakpoint) {
  var mediaQuery = '';
  if (breakpoint === 'always') {
    mediaQuery = '(min-width: 0px)';
  } else if (breakpoint === 'never') {
    mediaQuery = '(max-width: 0px)';
  } else {
    var minWidth = _breakpoint["default"].lmig.breakpoint[breakpoint].raw.toString();
    mediaQuery = "(min-width: ".concat(minWidth, "px)");
  }
  return (0, _useMediaQuery.useMediaQuery)(mediaQuery);
}